export const paleteItems = [
  {
    name: 'palete-item-01',
    color: '#ea402f',
  },
  {
    name: 'palete-item-02',
    color: '#df1962',
  },
  {
    name: 'palete-item-03',
    color: '#9728b2',
  },
  {
    name: 'palete-item-04',
    color: '#663bba',
  },
  {
    name: 'palete-item-05',
    color: '#4452b8',
  },
  {
    name: 'palete-item-06',
    color: '#3f97f6',
  },
  {
    name: 'palete-item-07',
    color: '#3caaf7',
  },
  {
    name: 'palete-item-08',
    color: '#3fbdd5',
  },
  {
    name: 'palete-item-09',
    color: '#2f9688',
  },
  {
    name: 'palete-item-10',
    color: '#5aaf4b',
  },
  {
    name: 'palete-item-11',
    color: '#90c341',
  },
  {
    name: 'palete-item-12',
    color: '#cddc21',
  },
  {
    name: 'palete-item-13',
    color: '#fcea1b',
  },
  {
    name: 'palete-item-14',
    color: '#f9c000',
  },
  {
    name: 'palete-item-15',
    color: '#f79700',
  },
  {
    name: 'palete-item-16',
    color: '#f5550f',
  },
  {
    name: 'palete-item-17',
    color: '#765547',
  },
  {
    name: 'palete-item-18',
    color: '#9e9e9e',
  },
  {
    name: 'palete-item-19',
    color: '#637d8c',
  },

];
